import axios, { AxiosResponse, AxiosError } from "axios";
import { useLocation } from 'react-router-dom';
import { Variables, isLocal, isProd, isSyst } from "./utils/endpoints";

//API call to the /legacy-login endpoint
export async function PostLegacyLogin(language: string, TicketID: string): Promise<void> {
    let url: string = "";
    let getlegacyroleurl: string = "";
    let setlegacyroleurl: string = "";
    let legacyAgreement: string = "";
    let defaultRole: boolean = false;
    let ebankingRoleType: boolean = true;

    const host = window.location.host;
    if (isLocal(host) || isSyst(host)) {
        url = Variables.postLegacyLoginUrl.syst;
        getlegacyroleurl = Variables.getlegacyAgreement.syst;
        setlegacyroleurl = Variables.setlegacyRole.syst;
    }
    if (isProd(host)) {
        url = Variables.postLegacyLoginUrl.prod;
        getlegacyroleurl = Variables.getlegacyAgreement.prod;
        setlegacyroleurl = Variables.setlegacyRole.prod;
    }
    url += language.toUpperCase();
    console.log(url);
    var config = {
        headers: {
            'Content-Type': 'application/json'
        },
        withCredentials: true
    };
    var roleconfig = {
        headers: {
            'Content-Type': 'application/json'
        },
        withCredentials: true
    };
    const WebpaymentRoleSelectionURL = WebpaymentsRoleSelectionURLConstruction(language, TicketID);
    //const WebpaymentPageURL = WebpaymentsURLConstruction(language, TicketID);
    try {
        const response: AxiosResponse<any> = await axios.get(getlegacyroleurl, roleconfig);
        if (response.status === 200 && response.data.ReturnCode === "0") {
            // console.log("positive response getlegacyrole", response.data);
            if (response.data.Roles && response.data.Roles.RolesList &&
                response.data.Roles.RolesList.length === 1 &&
                response.data.Roles.RolesList[0].systemUserId &&
                response.data.Roles.RolesList[0].roleStatus === 'A') {
                legacyAgreement = response.data.Roles.RolesList[0].systemUserId;
                setlegacyroleurl = setlegacyroleurl + "/" + legacyAgreement + "/" + Variables.legacysetasactive + "?"
                    + Variables.setDefaultfalse + "&" + Variables.removeDefaultfalse;
                if (response.data.Roles.RolesList[0].roleType === 'PRIVATE') {
                    ebankingRoleType = true;
                }
                else {
                    ebankingRoleType = false;
                }
                try {
                    const response: AxiosResponse<any> = await axios.post(setlegacyroleurl, {}, roleconfig);
                    if (response.status === 200) {
                        console.log("Success response, redirecting to WB URL");
                        defaultRole = true;
                    }
                    else {
                        console.log("negative response", response);
                    }
                }
                catch (error) {
                    console.error("Error during setlegacyrole:", error);
                }
            }
            else if (response.data.Roles && response.data.Roles.RolesList &&
                response.data.Roles.RolesList.length > 1) {
                const role = response.data.Roles.RolesList.find((role: any) => role.roleStatus === 'A' && role.roleDefault === 'Y');

                const systemUserId = role ? role.systemUserId : null;
                ebankingRoleType = role ? role.roleType === 'PRIVATE' : false;
                if (systemUserId !== null) {
                    setlegacyroleurl = setlegacyroleurl + "/" + systemUserId + "/" + Variables.legacysetasactive + "?"
                        + Variables.setDefaultfalse + "&" + Variables.removeDefaultfalse;
                    try {
                        const response: AxiosResponse<any> = await axios.post(setlegacyroleurl, {}, roleconfig);
                        if (response.status === 200) {
                            console.log("Success response, redirecting to WB URL");
                            defaultRole = true;
                        }
                        else {
                            console.log("negative response", response);
                        }
                    }
                    catch (error) {
                        console.error("Error during setlegacyrole:", error);
                    }

                    console.log("more than one role");
                }
                else {
                    console.log("more than one role");
                }
            }
            else {
                console.log("invalid response getlegacyrole", response);
            }
        }
        else {
            console.log("negative response getlegacyrole", response);
        }
    }
    catch (error) {
        const axiosError = error as AxiosError;
        console.error("Error during getlegacyrole:", axiosError.message);
        if (axiosError.response) {
            // Handle server-side errors
            console.error("Server responded with an error getlegacyrole:", axiosError.response.status, axiosError.response.data);
        }
    }
    try {
        const response: AxiosResponse<any> = await axios.post(url, null, config);
        const WebpaymentPageURL = WebpaymentsURLConstruction(language, TicketID, ebankingRoleType);
        if (response.status === 200) {
            if (defaultRole === true) {
                console.log("Success response, redirecting to WB URL");
                window.location.replace(WebpaymentPageURL);
            }
            else {
                console.log("Success response, redirecting to WB URL");
                window.location.replace(WebpaymentRoleSelectionURL);
            }
        }
        else {
            console.log("negative response", response);
            window.location.replace(WebpaymentRoleSelectionURL);
        }
    } catch (error) {
        const axiosError = error as AxiosError;
        console.error("Error during legacy login:", axiosError.message);
        if (axiosError.response) {
            // Handle server-side errors
            console.error("Server responded with an error:", axiosError.response.status, axiosError.response.data);
        }
        throw error;
    }
};

//API call to the /logout endpoint
export async function PostLegacyLogout(RedirectUrl: string): Promise<void> {
    let url: string = "";
    const host = window.location.host;
    console.log("post logout call");
    if (isLocal(host) || isSyst(host)) {
        url = Variables.postLegacyLogoutUrl.syst;
    }
    if (isProd(host)) {
        url = Variables.postLegacyLogoutUrl.prod;
    }
    var config = {
        headers: {
            'Content-Type': 'application/json'
        },
        withCredentials: true
    };
    try {
        const response: AxiosResponse<any> = await axios.post(url, null, config);
        if (response.status === 200) {
            console.log("post logout response", response);
            console.log("Success response, redirecting to OK or Cancel URL");
            window.location.href = RedirectUrl;
        }
        else {
            console.log("post logout failure", response);
            console.log("Success response, redirecting to OK or Cancel URL");
        }
    } catch (error) {
        const axiosError = error as AxiosError;
        console.error("Error during legacy logout:", axiosError.message);
        if (axiosError.response) {
            // Handle server-side errors
            console.error("Server responded with an error:", axiosError.response.status, axiosError.response.data);
        }
        window.location.href = RedirectUrl;
    }
}

//Given the language and the TicketID, creates the direct WP URL
export function WebpaymentsURLConstruction(language: string, TicketID: string, ebankingRoleType: boolean): string {
    let url: string = Variables.httpsString;
    let isSystOrLocal: boolean = true;
    let encodedTicketID = encodeURIComponent(TicketID);
    const host = window.location.host;
    if (isLocal(host) || isSyst(host)) {
        isSystOrLocal = true;
    }
    if (isProd(host)) {
        isSystOrLocal = false;
    }
    if (ebankingRoleType === true) {
        switch (language) {
            case Variables.englishLanguageCode:
                url += isSystOrLocal ? Variables.WebpaymentsEnglishBaseUrl.syst : Variables.WebpaymentsEnglishBaseUrl.prod;
                url += isSystOrLocal ? Variables.WebpaymentsContextEnglishString.syst : Variables.WebpaymentsContextEnglishString.prod;
                url += Variables.ticketIdDecoded + encodedTicketID;
                break;
            case Variables.finnishLanguageCode:
                url += isSystOrLocal ? Variables.WebpaymentsFinnishBaseUrl.syst : Variables.WebpaymentsFinnishBaseUrl.prod;
                url += isSystOrLocal ? Variables.WebpaymentsContextFinnishString.syst : Variables.WebpaymentsContextFinnishString.prod;
                url += Variables.ticketIdDecoded + encodedTicketID;
                break;
            case Variables.swedishLanguageCode:
                url += isSystOrLocal ? Variables.WebpaymentsSwedishBaseUrl.syst : Variables.WebpaymentsSwedishBaseUrl.prod;;
                url += isSystOrLocal ? Variables.WebpaymentsContextSwedishString.syst : Variables.WebpaymentsContextSwedishString.prod;
                url += Variables.ticketIdDecoded + encodedTicketID;
                break;
            default:
                //Put english as default case
                url += isSystOrLocal ? Variables.WebpaymentsEnglishBaseUrl.syst : Variables.WebpaymentsEnglishBaseUrl.prod;
                url += isSystOrLocal ? Variables.WebpaymentsContextEnglishString.syst : Variables.WebpaymentsContextEnglishString.prod;
                url += Variables.ticketIdDecoded + encodedTicketID;
                break;
        }
        return url;
    }
    else {
        url += isSystOrLocal ? Variables.WebpaymentsRoleSelectionBusinessBaseUrl.syst : Variables.WebpaymentsRoleSelectionBusinessBaseUrl.prod;
        url += isSystOrLocal ? Variables.WebpaymentsContextEnglishString.syst : Variables.WebpaymentsContextEnglishString.prod;
        url += Variables.ticketIdDecoded + encodedTicketID;
        return url;
    }
}

//Given the language and the TicketID, creates the Role Selection URL
export function WebpaymentsRoleSelectionURLConstruction(language: string, TicketID: string): string {
    let url: string = Variables.httpsString;
    let isSystOrLocal: boolean = true;
    let encodedTicketID = encodeURIComponent(TicketID);
    const host = window.location.host;
    if (isLocal(host) || isSyst(host)) {
        isSystOrLocal = true;
    }
    if (isProd(host)) {
        isSystOrLocal = false;
    }
    switch (language) {
        case Variables.englishLanguageCode:
            url += isSystOrLocal ? Variables.WebpaymentsRoleSelectionEnglishBaseUrl.syst : Variables.WebpaymentsRoleSelectionEnglishBaseUrl.prod;
            url += isSystOrLocal ? Variables.WebpaymentsContextEnglishString.syst : Variables.WebpaymentsContextEnglishString.prod;
            url += Variables.ticketIdDecoded + encodedTicketID;
            break;
        case Variables.finnishLanguageCode:
            url += isSystOrLocal ? Variables.WebpaymentsRoleSelectionFinnishBaseUrl.syst : Variables.WebpaymentsRoleSelectionFinnishBaseUrl.prod;
            url += isSystOrLocal ? Variables.WebpaymentsContextFinnishString.syst : Variables.WebpaymentsContextFinnishString.prod;;
            url += Variables.ticketIdDecoded + encodedTicketID;
            break;
        case Variables.swedishLanguageCode:
            url += isSystOrLocal ? Variables.WebpaymentsRoleSelectionSwedishBaseUrl.syst : Variables.WebpaymentsRoleSelectionSwedishBaseUrl.prod;
            url += isSystOrLocal ? Variables.WebpaymentsContextSwedishString.syst : Variables.WebpaymentsContextSwedishString.prod;
            url += Variables.ticketIdDecoded + encodedTicketID;
            break;
        default:
            //Put english as default case
            url += isSystOrLocal ? Variables.WebpaymentsRoleSelectionEnglishBaseUrl.syst : Variables.WebpaymentsRoleSelectionEnglishBaseUrl.prod;
            url += isSystOrLocal ? Variables.WebpaymentsContextEnglishString.syst : Variables.WebpaymentsContextEnglishString.prod;;
            url += Variables.ticketIdDecoded + encodedTicketID;
            break;
    }
    return url;
}

//Function to create the AuthMS URL to start the logon process given the language and TicketID values
export function createUrl(language: string, ticketID: string): string {
    let AuthMsUrl: string = "";
    let currentLanguage: string = "";
    let destinationBaseUrl: string = "";
    let ticketIdQuery: string = "";
    let destinationUrlQuery: string = "";
    const host = window.location.host;
    if (isLocal(host) || isSyst(host)) {
        AuthMsUrl = Variables.preloginBaseUrl.syst;
        currentLanguage = Variables.currentLanguage;
        destinationBaseUrl = Variables.destinationBaseUrl.syst;
        ticketIdQuery = Variables.ticketIdEncodedQueryParameter;
        destinationUrlQuery = Variables.destinationUrl;
    }
    if (isProd(host)) {
        AuthMsUrl = Variables.preloginBaseUrl.prod;
        currentLanguage = Variables.currentLanguage;
        destinationBaseUrl = Variables.destinationBaseUrl.prod;
        ticketIdQuery = Variables.ticketIdEncodedQueryParameter;
        destinationUrlQuery = Variables.destinationUrl;
    }
    var url = AuthMsUrl;
    url = url + currentLanguage + language;
    var destinationUrl = destinationBaseUrl + language + ticketIdQuery + ticketID;
    url = url + destinationUrlQuery + destinationUrl;
    return url;
}

//Use to search the query parameters
export function useQuery() {
    return new URLSearchParams(useLocation().search);
}